import { axiosInstance } from '../../config/axiosConfig';
import { AxiosError, AxiosResponse } from 'axios';
import {
    IDeleteTaxSchedulesResponse,
    ITaxNewsResponse,
    ITaxSchedulesResponse,
    IDeleteScheduleRequest,
    ITaxNewsCountriesResponse,
    ITaxNewsParams,
    IUploadedDTSchedulesResponse,
} from '../types/home.type';
import { endPointUrls } from '../constants/endPoints';

const getTaxNews = async ({
    inputParameters,
}: { 
    inputParameters :ITaxNewsParams;

}): Promise<ITaxNewsResponse> => {
    return axiosInstance
        .post(endPointUrls.getTaxNews,inputParameters)
        .then((res: AxiosResponse<ITaxNewsResponse>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const getTaxSchedules = async ({
    pageSize = '10',
    isUserGroup = false,
    pageNumber = '0',
    fieldName = 'taxScheduleId',
    sortOrder = 'desc',
    searchString = '',
}): Promise<ITaxSchedulesResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getTaxSchedules, {
            isUserGroup,
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const getUploadedDTSchedules = async ({
    isUserGroup = false,
    pageSize = 10,
    pageNumber = 0,
    fieldName = 'schedule_document_id',
    sortOrder = 'desc',
    searchString = '',
}): Promise<IUploadedDTSchedulesResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getUploadedDTSchedules, {
            isUserGroup,
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};


const getTaxNewsCountries = async ({
    countryCodes,
    pageSize = '-1',
    pageNumber = '0',
    fieldName = 'countryName',
    sortOrder = 'Asc',
    searchString = '',
}: {
    countryCodes: string[]; // or the appropriate type for countryCodes
    pageSize?: string;
    pageNumber?: string;
    fieldName?: string;
    sortOrder?: string;
    searchString?: string;
}): Promise<ITaxNewsCountriesResponse> => {
    try {
        const response = await axiosInstance.post(endPointUrls.getTaxNewsCountries, {
            countryCodes: countryCodes,
            pagination: {
                pageNumber,
                pageSize,
                fieldName,
                sortOrder,
                searchString,
            },
        });
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const deleteTaxSchedule = async (requestBody: IDeleteScheduleRequest): Promise<IDeleteTaxSchedulesResponse> => {
    try {
        const response = await axiosInstance.patch(endPointUrls.updateTaxSchedules, requestBody);
        const data = await response.data;
        return data;
    } catch (error) {
        throw error;
    }
};

const downloadHelpManual = (): Promise<any> => {
    return axiosInstance
        .get(endPointUrls.downloadHelpManual, { responseType: 'blob' })
        .then((res: AxiosResponse<any>) => {
            return res.data;
        })
        .catch((error: AxiosError) => {
            throw error;
        });
};

const homeServices = {
    getTaxNews,
    getTaxSchedules,
    getUploadedDTSchedules,
    getTaxNewsCountries,
    deleteTaxSchedule,
    downloadHelpManual,
};

export default homeServices;
